<spark-shared-data-table-wrapper
  [title]="title"
  [downloading]="downloading"
  (downloadClicked)="downloadClicked()">
  <ng-container table-definition>
    <div class="row" *appLoad="let data of data$">
      <div class="col">
        <div class="row mb-3">
          <div class="col">
            <ngx-datatable
              [rows]="data.data"
              [columns]="columns"
              [reorderable]="true"
              [swapColumns]="false"
              rowHeight="auto"
              columnMode="force"
              *ngIf="data">
              <ngx-datatable-column name="Opportunity type">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.opportunityType }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Name">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{
                    [
                      row.title,
                      [row.firstName, row.middleName, row.lastName]
                        | join: ' ':true
                    ] | join: '. ':true
                  }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Settlement date">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  {{ value | date:'dd/MM/yyyy'}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Settlement amount">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  {{ value  | currency: '' : 'symbol-narrow' : '1.0-0' }}
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </div>
        <div class="row">
          <div class="col d-flex justify-content-end">
            <spark-shared-pagination
              [currentPage]="data.pagination.currentPage"
              [size]="data.pagination.pageSize"
              [count]="data.pagination.totalItems"
              (gotoPage)="
                pageChanged($event, data.pagination.pageSize)
              "></spark-shared-pagination>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</spark-shared-data-table-wrapper>
